/**
 * Service that sends pictures to AI servers
 * Each picture is analysed (face, emotions, duplicates, ....)
 * If more at least 24 pictures are sent, a story is created
 * Events :
 * "analyse-finished" : all photos were analysed
 * "not-enougth-photos" : not enough photos to create a story
 * "story-created" : a story was created
 * "error-analyse" : an error occured during analyse or story creation
 */
fx.service(class AIService extends fx.Service
{
    constructor(model)
    {
        super();

        this.model = model.creationModel;

        this._queue = [];
        this._processedFiles = [];
        this._processLaterFiles = [];
        this._nberrors = 0;
        this._totalFiles = 0;
        this._createTries = 0;

        this.MAX_SIMULTANEOUS_PROCESS = fx.get("settings").maxAIProcesses;
        this.MAX_PROCESS_ERRORS = 10;
        
        this._requests = [];

        this._story = null
    }

    init()
    {
        if ( !this.initialized)
        {
             this.on("photo-upload", this._onPhotoExtracted, fx.service("MediasUploader"));
             this.on("files-selected", this._onFilesSelected, fx.service("MediasUploader"));

             this.on("photo-upload-error", this._onPhotoUploaded, fx.service("MediasUploader"));
             this.on("photo-upload-finished", this._onPhotoUploaded, fx.service("MediasUploader"));

             this.on("event", this._onDataEvent, this.model);

             this.initialized = true;
        }
    }


    get hasStory()
    {
        return this._story != null;
    }

    get story()
    {
        return this._story;
    }


    get waiting()
    {
        return this._processLaterFiles.length > 0;
    }

    get processing()
    {
        return this._processing || this._processingStory;
    }
    
    get progress()
    {
        if (this._totalFiles == 0)
            return 100;
        
        return Math.ceil( (this._processedFiles.length + this._processLaterFiles.length ) * 100 / this._totalFiles);
    }

    get facialDataReceived()
    {
        return true;   
    }

    get duplicateDataReceived()
    {
        return true;
    }


    get heicExtractor()
    {
        if (!this._heicExtractor)
        {
            this._heicExtractor = new shared.extractors.HeicExtractor();
            this.on("photo-extracted", this._onHeicPhotoExtracted, this._heicExtractor);
        }

        return this._heicExtractor;
    }
    
    newRequest()
    {
        let request = new requests.AIRequest(this.model);
        this.on("photo-analyse-started", this._photoAnalyseStarted, request)
        this.on("photo-analyse-error", this._photoAnalyseError, request)
        this.on("photo-analyse-finished", this._photoAnalyseFinished, request)
      
        this._requests.push(request);

        return request;
    }

    removeRequest(request)
    {
        this.off("photo-analyse-started", this._photoAnalyseStarted, request)
        this.off("photo-analyse-error", this._photoAnalyseError, request)
        this.off("photo-analyse-finished", this._photoAnalyseFinished, request)
       
        this._requests.remove(request);
    }

    _onDataEvent(e)
    {
        let event = e.detail.event;

        if (event.type == "facebook-photos-added" ||
            event.type == "google-photos-added" ||
            event.type == "album-photos-copied" ||
            event.type == "instagram-photos-added" )

            this._onFilesSelected(event);        
    }

    _onFilesSelected(event)
    {
        this._totalFiles += event.detail.length;

        /*if (event.detail.length > 0)
            this._processing = true;*/
    }

    _onPhotoExtracted(event)
    {
        this._queue.push(event.detail);

        this.process();
    }

    processMobilePhoto(rawphotos)
    {
        for (let i = 0; i < rawphotos.length; i++)
        {
            let photo = this.model.photos.find({id : rawphotos.getItemAt(i).id });
            if (photo)
            {
                this._queue.push(photo);
                this._totalFiles += 1;
            }
        }
        
        this._processing = true;

        this.process();
    }

    _onPhotoUploaded()
    {
        // case of HEIC files, we wait until they are uploaded before to process them
        if (this._processLaterFiles.length > 0)
        {
            let notHeic = [];
            for (let i = 0; i < this._processLaterFiles.length; i++)
            {
                let photo = this._processLaterFiles.getItemAt(i);
                if (!photo.isHeic)
                    notHeic.push(photo);
            }

            // Extract HEIC Files
            
            // move not isHeic files to queue file
            for (let i = 0; i < notHeic.length; i++)
            {
                let photo = notHeic.getItemAt(i);
                this._processLaterFiles.remove(photo),
                this.heicExtractor.process(photo);
            }
            
            if (notHeic.length.length > 0)
                this.process();
        }
            
    }
    

    _onHeicPhotoExtracted(event)
    {
        this._queue.push( event.detail );
        this.process();
    }


    process()
    {
        if (this._nberrors > this.MAX_PROCESS_ERRORS && this._requests.length == 0)
        {
           this._endProcess();
        }
        else
        if (this._processedFiles.length == this._totalFiles)
        {
            this._endProcess();
        }
        else
        {
            this._processing = true;

            while (this._queue.length > 0 && this._requests.length < this.MAX_SIMULTANEOUS_PROCESS && this._nberrors <= this.MAX_PROCESS_ERRORS)
            {
                let photo = this._queue.shift();
                
                if (photo.isHeic) // we don't process HEIX pictures for now
                {
                    this._processLaterFiles.push(photo);
                }
                else 
                {
                    this._processedFiles.push(photo);
                    this.newRequest().analysePhoto(photo);
                }
                    
            }
        }

        this.trigger("process");
    }



    _photoAnalyseStarted()
    {

    }

    _photoAnalyseError(event)
    {
        this.removeRequest(event.detail);

        this._nberrors++;
        this.process();
    }

    _photoAnalyseFinished(event)
    {
        this.removeRequest(event.detail);

        this.process();
    }


    _endProcess()
    {
        if (this._processLaterFiles.length == 0)
        {
            if (this._requests.length == 0)
                this._analyseFinished();
        }
    }
  
    _analyseFinished()
    {
        this._processing = false;
        
        this._nberrors = 0;
        this._totalFiles = 0;
        this._processedFiles = [];
    
        if (this._nberrors > 0)
            this.trigger("error-analyse");
        else
        {
            this.trigger("analyse-finished");
                
            this.createStory();
        }

        if (fx.get("app") == "book") 
            fx.service("MediasUploader").process();
    }


    // ----------------- Process Photos -------------------//
    createStory()
    {
        if (this._processingStory)
            return;

        this.post( 
            this.model.servers.aiServers.getItemAt(0).url + "/v2/create",
            { 
                bookid : this.model.creation.id,
                lang : fx.currentLang(),
            }, 
            this._onCreateStory,
            {timeout : 120000, maxTries : 3}
        );

        this._processingStory = true;
    }

    _onCreateStory(data)
    {
        this._processingStory = false;

        if (data.error)
        {
            // if still error, throught event so create Chronological is applied    
            this.trigger("error-create");
        }
        else
        {
            this._story = data;
            this._createTries = 0;
            this.trigger("story-created");

            this.model.creator.createBook( this._story );
        }
    }

});
